import Entity from "entity";
import ValidatorHelper from "functions/ValidatorHelper";
import { ColumnActions } from "./functions";

export default class Fazenda extends Entity {
    static get collectionUID() {
        return "ValueCustomForm/i7UqQDaM6qTjPSyUDCwl/Values";
    }
    async initialize() {
        this.data.status = "ATIVO";
    }
    static async onQuery(collection) {
        return collection.where("status", "==", "ATIVO").orderBy("nomeFazenda");
    }

    static get labelField() {
        return "nomeFazenda";
    }

    async preSave(entity) {
        const { talhoesFazenda } = entity.data

        if (talhoesFazenda && talhoesFazenda.length > 0) {
            talhoesFazenda.forEach((talhao) => {
                if (talhao.areaNoMapStr) {
                    entity.data.hasMap = true
                } else {
                    entity.data.hasMap = false
                }
            })
        }
    }

    static get searchColumns() {
        return [
            {
                // field: "COL_EDIT",
                headerName: "Ações", flex: 1,
                renderCellValue: (row) => {
                    console.log('row', row)
                    // return <Edit />
                    return <ColumnActions row={row} />
                },

            },
            { field: "cliente.nome", headerName: "Cliente", flex: 2, filter: true },
            { field: "codFazenda", headerName: "Cód. Fazenda", flex: 1, filter: true },
            { field: "nomeFazenda", headerName: "Nome Fazenda", flex: 2, filter: true },
            { field: "areaTotalFazenda", headerName: "Área Total", flex: 1 },
        ];
    }

    static async validFieldErrors(values) {
        // console.log('validFieldErrors', values)

        let v = new ValidatorHelper();
        v.addRequired('nomeFazenda', "Nome");
        let errorsMessage = v.valid(values);

        if (errorsMessage.length) {
            return errorsMessage
        }

        return null
    }

}
